export const STATUS = {
  SIGN_IN: 'signin',
  FORGET_PASSWORD: 'forgetPassword',
  RESET_PASSWORD: 'resetPassword',
  SIGN_UP: 'signup',
  COMPLETE_SIGN_UP: 'completeSignUp',
};

export const CONTENT = {
  [STATUS.SIGN_IN]: {
    title: 'SIGN IN',
    message: '還不是會員嗎？',
    link: '註冊帳號',
  },

  [STATUS.FORGET_PASSWORD]: {
    title: 'FORGET PASSWORD',
    message: '再試試？',
    link: '登入帳號',
  },

  [STATUS.RESET_PASSWORD]: {
    title: 'RESET PASSWORD',
    message: '再試試？',
    link: '登入帳號',
  },

  [STATUS.SIGN_UP]: {
    title: 'SIGN UP',
    message: '已經是會員了？',
    link: '登入帳號',
  },

  [STATUS.COMPLETE_SIGN_UP]: {
    title: 'COMPLETE SIGN UP',
    message: '完成註冊程序',
    link: '登入帳號',
  },
};
